import { BrowserRouter } from 'react-router-dom';
import './App.css';
import Root from './routes/Root';
import { ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import I18nWrapper from './config/I18nWrapper';


function App() {



  return (
    <div className="App">
      <I18nWrapper>
        <BrowserRouter>
          <ToastContainer position="top-right" />

          <Root />
        </BrowserRouter>
      </I18nWrapper>

    </div>
  );
}

//#13072e   dark
//#3e2080   light
//#efa9fa   pink
export default App;
